"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListTelemetry = /** @class */ (function () {
    function ListTelemetry(telemetry) {
        var _this = this;
        this.telemetry = telemetry;
        this.Open = function () { return _this.telemetry.send('Jumpstart_List_Open'); };
        this.Error = function (code) {
            _this.telemetry.send('Jumpstart_List_Error', {
                Code: code,
            });
        };
        this.Select = function (templateId, templateName, connectionType, selectMethod) {
            _this.telemetry.send('Jumpstart_List_Select', {
                TemplateId: templateId,
                TemplateName: templateName,
                ConnectionType: connectionType,
                SelectMethod: selectMethod,
            });
        };
        this.LearnMore = {
            Click: function () { return _this.telemetry.send('Jumpstart_List_LearnMore_Click'); },
        };
        this.Filter = {
            Open: function () { return _this.telemetry.send('Jumpstart_List_Filter_Open'); },
            Select: function (selection) {
                _this.telemetry.send('Jumpstart_List_Filter_Select', {
                    Selection: selection,
                });
            },
        };
    }
    return ListTelemetry;
}());
exports.ListTelemetry = ListTelemetry;
//# sourceMappingURL=ListTelemetry.js.map